import { render, staticRenderFns } from "./Teaser.vue?vue&type=template&id=2dd7762a&scoped=true"
import script from "./Teaser.vue?vue&type=script&lang=js"
export * from "./Teaser.vue?vue&type=script&lang=js"
import style1 from "./Teaser.vue?vue&type=style&index=1&id=2dd7762a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd7762a",
  null
  
)

export default component.exports